const formatPhone = (phone, partly = false, withMaxlength = false) => {
  if (!phone) {
    return phone;
  }
  if (phone.length === 11 && phone[0] === '1') {
    return `${phone.substr(1, 3)}-${phone.substr(4, 3)}-${phone.substr(7)}`;
  }
  if (partly) {
    let result = '';
    if (phone.length < 3) {
      return phone;
    }
    result += phone.substr(0, 3);
    if (phone.length === 3) {
      return result;
    }
    if (phone.length <= 6) {
      return `${result}-${phone.substr(3, phone.length + 1)}`;
    }
    return `(${phone.substr(0, 3)}) ${phone.substr(3, 3)}-${phone.substr(6, withMaxlength ? 4 : phone.length + 1)}`;
  }
  return phone;
};

const clearPhone = (phone) => {
  if (!phone) {
    return phone;
  }
  return phone.replace(/[^a-z0-9]/gi, '').replace(/ /gi, '').substring(0, 10);
};

export {
  clearPhone,
  formatPhone,
};

